<template>
    <div>
        <div class="search-wrapper col-12 text-right">
            <base-input v-model="searchQuery" prepend-icon="fas fa-search"
                placeholder="Search..." />
        </div>

        <el-table :data="tableData" row-key="id" id="venues_data_table" v-loading="loading"
            header-row-class-name="thead-light" @sort-change="sortChangeVenues" @row-click="rowClicked">
            <el-table-column label="Name" min-width="220px" prop="name" sortable="custom">
                <template v-slot="{ row }">
                    <div class="media align-items-center">
                        <div class="media-body">
                            <span class="font-weight-600 name mb-0 text-sm">{{
                                row.name
                                }}</span>
                        </div>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="Address" prop="address" min-width="250px">
                <template v-slot="{ row }">
                    {{ row.address.address }}
                </template>
            </el-table-column>

            <el-table-column label="Venue Specialist" min-width="250px">
                <template v-slot="{ row }">
                    {{ row.venue_specialist_name }}
                </template>
            </el-table-column>
        </el-table>

        <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap mt-3">
            <div>
                <p class="card-category">
                    Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
                </p>
            </div>
            <base-pagination class="pagination-no-border" v-model="pagination.currentPage"
                :per-page="pagination.perPage" :total="total">
            </base-pagination>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { Table, TableColumn } from "element-ui";
import { BasePagination } from "@/components";
import tableMixin from "@/helpers/tableMixin";

export default {
    name: "venues-tab",
    mixins: [tableMixin],
    components: {
        BasePagination,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
    },
    data() {
        return {
            propsToSearch: "name",
            loading: true,
            sortOptions: {
                prop: 'name',
                order: 'ascending',
            },
        };
    },
    async created() {
        await this.$store.dispatch("venues/getAll", { country: this.country });
        this.loading = false;
    },
    computed: {
        queriedData() {
            let data = [...this.$store.state.venues.items];
            if (this.searchQuery) {
                const propsToSearch = this.propsToSearch;
                const searchQuery = this.searchQuery;
                data = data.filter(function (item) {
                    return item[propsToSearch].toLowerCase().indexOf(searchQuery.toLowerCase()) !== -1;
                });
            }

            return data;
        },
        tableData() {
            let data = [...this.queriedData];
            data.sort((a, b) => {
                if (this.sortOptions.prop) {
                    const prop = this.sortOptions.prop;
                    const order = this.sortOptions.order === "ascending" ? 1 : -1;
                    return a[prop] > b[prop] ? order : -order;
                }
                return 0;
            });
            data = data.slice(this.from, this.from + this.pagination.perPage);
            return data;
        },
        ...mapState("country/", {
            country: (state) => state.country || 'AU',
        }),
    },
    methods: {
        rowClicked(row) {
            this.$router.push({ name: 'VenueDetails', params: { id: row.id } });
        },
        sortChangeVenues({ prop, order }) {
            this.sortOptions.prop = prop;
            this.sortOptions.order = order;
            this.pagination.currentPage = 1;
        },
    },
    watch: {
        searchQuery() {
            this.pagination.currentPage = 1;
        },
    },
};
</script>

<style scoped>
.el-table .cell {
    word-break: normal;
}

.el-table--enable-row-hover .el-table__body tr:hover>td {
    background-color: #f6f9fc !important;
    cursor: pointer;
}

.search-wrapper {
    margin-top: 10px;
}
</style>
